import { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams, Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import api from '../api';

export default function Quiz() {
  const { quizId } = useParams();
  const [sp] = useSearchParams();
  const trilhaId = sp.get('trilha');
  const itemId = sp.get('item');
  const navigate = useNavigate();

  const [quiz, setQuiz] = useState(null);
  const [questoes, setQuestoes] = useState([]);
  const [respostas, setRespostas] = useState({});
  const [resultado, setResultado] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  const carregar = useCallback(() => {
    setCarregando(true); setResultado(null); setRespostas({});
    api.get(`/quizzes/${quizId}`)
      .then(({ data }) => { setQuiz(data.quiz); setQuestoes(data.questoes); })
      .catch(err => setErro(err.response?.data?.error || 'Erro ao carregar quiz'))
      .finally(() => setCarregando(false));
  }, [quizId]);

  useEffect(() => { carregar(); }, [carregar]);

  const marcar = (qId, oId) => setRespostas(r => ({ ...r, [qId]: oId }));
  const todasRespondidas = questoes.length > 0 && questoes.every(q => respostas[q.id] != null);
  const correcaoDe = (qId) => resultado?.correcao?.find(c => c.questao_id === qId);

  async function enviar() {
    setEnviando(true);
    try {
      const body = { respostas };
      if (itemId) body.trilha_item_id = parseInt(itemId);
      const { data } = await api.post(`/quizzes/${quizId}/responder`, body);
      setResultado(data);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao enviar respostas');
    } finally { setEnviando(false); }
  }

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 720 }}>
        <Link to={trilhaId ? `/academia/trilhas/${trilhaId}` : '/academia'} className="doc-voltar">
          <i className="bi bi-arrow-left"></i> {trilhaId ? 'Trilha' : 'Academia'}
        </Link>
        {carregando && <div>Carregando…</div>}
        {erro && <div className="erro">{erro}</div>}

        {quiz && (
          <>
            <h1 style={{ color: 'var(--verde)', fontWeight: 700, marginBottom: 6 }}>{quiz.titulo}</h1>
            {quiz.descricao && <p style={{ color: 'var(--texto-suave)' }}>{quiz.descricao}</p>}
            <div className="quiz-min">Nota mínima: <strong>{quiz.nota_minima}%</strong></div>

            {resultado && (
              <div className={`quiz-resultado ${resultado.passou ? 'quiz-resultado--ok' : 'quiz-resultado--fail'}`}>
                <i className={`bi ${resultado.passou ? 'bi-trophy-fill' : 'bi-emoji-frown-fill'}`}></i>
                <div>
                  <div className="quiz-resultado-nota">{resultado.nota}%</div>
                  <div>{resultado.passou ? 'Você passou! 🎉' : `Não foi dessa vez — mínimo ${resultado.nota_minima}%`}</div>
                  <div className="quiz-resultado-sub">{resultado.acertos} de {resultado.total} corretas</div>
                </div>
              </div>
            )}

            <div className="quiz-questoes">
              {questoes.map((q, i) => {
                const corr = correcaoDe(q.id);
                return (
                  <div className="quiz-questao" key={q.id}>
                    <div className="quiz-enunciado"><span className="quiz-num">{i + 1}</span> {q.enunciado}</div>
                    <div className="quiz-opcoes">
                      {q.opcoes.map(o => {
                        const sel = respostas[q.id] === o.id;
                        let cls = 'quiz-opcao';
                        if (resultado && corr) {
                          if (o.id === corr.correta_id) cls += ' quiz-opcao--certa';
                          else if (o.id === corr.marcada_id) cls += ' quiz-opcao--errada';
                        } else if (sel) cls += ' quiz-opcao--sel';
                        return (
                          <label key={o.id} className={cls}>
                            <input type="radio" name={`q${q.id}`} checked={sel} disabled={!!resultado} onChange={() => marcar(q.id, o.id)} />
                            <span>{o.texto}</span>
                          </label>
                        );
                      })}
                    </div>
                    {resultado && corr?.explicacao && (
                      <div className="quiz-explica"><i className="bi bi-info-circle"></i> {corr.explicacao}</div>
                    )}
                  </div>
                );
              })}
            </div>

            {!resultado ? (
              <button className="btn-centrao" disabled={!todasRespondidas || enviando} onClick={enviar}>
                {enviando ? 'Enviando…' : 'Enviar respostas'}
              </button>
            ) : (
              <div className="quiz-acoes">
                {resultado.passou
                  ? (trilhaId
                      ? <button className="btn-centrao" onClick={() => navigate(`/academia/trilhas/${trilhaId}`)}>Voltar à trilha</button>
                      : <Link to="/academia" className="btn-centrao">Voltar à Academia</Link>)
                  : <button className="btn-centrao" onClick={carregar}><i className="bi bi-arrow-repeat me-1"></i> Tentar de novo</button>}
              </div>
            )}
          </>
        )}
      </main>
    </>
  );
}
